import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_DARK_PURPLE, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_TEXT, PROMETHEAN_BLUE } from '../../../styles/colors/colors';
import { PROMETHEAN_BREAKPOINT_SM, PROMETHEAN_BREAKPOINT_XL } from '../../../styles/breakpoints/breakpoints';
var getResponsiveWidth = function getResponsiveWidth(fullScreen) {
  if (fullScreen) {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
      width: 1536,
      marginBottom: 70
    }, "@media screen and (max-width: ".concat(1536 + 128, "px) "), {
      width: 'calc(100vw - 128px)'
    }), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_XL - 1, "px) "), {
      width: 1280
    }), "@media screen and (max-width: ".concat(1280 + 128, "px) "), {
      width: 'calc(100vw - 128px)'
    }), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px) "), {
      width: 'calc(100vw)',
      marginBottom: 40
    });
  } else {
    return _defineProperty(_defineProperty({
      width: 954
    }, "@media screen and (max-width: ".concat(954 + 128, "px) "), {
      width: 'calc(100vw - 128px)'
    }), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px) "), {
      width: 'calc(100vw)'
    });
  }
};
export var StyledCarouselContainer = styled('div', {
  shouldForwardProp: function shouldForwardProp(propName) {
    return !(propName === 'fullScreen');
  }
})(function (_ref3) {
  var fullScreen = _ref3.fullScreen;
  return _objectSpread(_objectSpread({
    display: 'flex',
    justifyContent: 'center'
  }, getResponsiveWidth(fullScreen)), {}, {
    '.EmbersTemplate-marketingCarousel': {
      '&-transformed-container': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      '&-transformed-top': {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        height: 'fit-content'
      },
      '&-swiper-arrow': _defineProperty({
        display: 'inline-block',
        fontSize: 64,
        color: PROMETHEAN_TEXT,
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        borderRadius: '50%',
        '&:active': {
          background: 'none'
        },
        '&:focus-visible': {
          outlineWidth: 2,
          outlineOffset: -2,
          outlineColor: PROMETHEAN_BLUE,
          outlineStyle: 'solid'
        },
        '&-next': {
          marginLeft: 24
        },
        '&-prev': {
          marginRight: 24
        }
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px) "), {
        '&-next': {
          // marginRight: -24,
          marginLeft: 0
        },
        '&-prev': {
          // marginleft: -24,
          marginRight: 0
        }
      }),
      '&-pagination': {
        width: 'calc(100% - 128px - 48px)',
        textAlign: 'center',
        marginTop: 24,
        '.swiper-pagination-bullet': {
          width: 16,
          height: 16,
          background: 'rgba(139, 100, 165, 0.5)',
          margin: '0 8px',
          transition: 'background 0.3s',
          '&:hover': {
            background: '#9955c6'
          },
          '&-active': {
            position: 'relative',
            background: PROMETHEAN_DARK_PURPLE,
            '&:hover': {
              background: PROMETHEAN_DARK_PURPLE
            },
            '&:before': {
              position: 'absolute',
              left: -4,
              top: -4,
              content: '""',
              width: 24,
              height: 24,
              borderRadius: '50%',
              border: "2px solid ".concat(PROMETHEAN_PURPLE_PLUM)
            }
          }
        }
      }
    }
  });
});
export var StyledCarousel = styled('div')({
  width: '100%',
  img: {
    display: 'block',
    width: '100%'
  }
});